<div
[ngClass]="{
    'error-border': showErrorBorder
}"
>
    <app-ops-accordion #accordion [isOpen]="isOpen">
        <div ops-accordion-header
        class="form-accordion-header caption bold"
        >
            <div class="form-accordion-header-label">
                {{header}}
            </div>
            <div class="form-accordion-header-icon">
                <mat-icon
                *ngIf="showErrorBorder"
                svgIcon="error"
                class="form-accordion-icon-error"
                ></mat-icon>
            </div>
            <div class="subtitle-small light">{{accordion.isOpen? "-" : "+"}}</div>
        </div>
        <div ops-accordion-content class="form-accordion-body">
            <ng-content></ng-content>
        </div>
    </app-ops-accordion>
</div>